// capPoints.js
export default {
    ct: [
        { section: 0, caps: [
                { name: "BLACTOT", position: { lat: 1391, lng: 345 }, radius: 50 },
                { name: "502ND START", position: { lat: 947, lng: 328 }, radius: 50 },
                { name: "FARM RUINS", position: { lat: 616, lng:  312 }, radius: 50 },
            ]
        },
        { section: 1, caps: [
                { name: "PUMPING STATION", position: { lat: 1293, lng: 634 }, radius: 50 },
                { name: "RUINS", position: { lat: 970, lng: 740 }, radius: 29 },
                { name: "DERAILED TRAIN", position: { lat: 704, lng: 604 }, radius: 50 },
            ]
        },
        { section: 2, caps: [
                { name: "CANAL CROSSING", position: { lat: 1388, lng: 1063 }, radius: 50 },
                { name: "TOWN CENTER", position: { lat: 1003, lng: 1013 }, radius: 50 },
                { name: "TRAIN STATION", position: { lat: 717, lng: 1005 }, radius: 50 },
            ]
        },
        { section: 3, caps: [
                { name: "CUSTOMS", position: { lat: 1337, lng: 1414 }, radius: 50 },
                { name: "RAIL CROSSING", position: { lat: 1057, lng: 1448 }, radius: 50 },
                { name: "MONT HALAIS", position: { lat: 479, lng: 1343 }, radius: 40 },
            ]
        },
        { section: 4, caps: [
                { name: "CANAL LOCKS", position: { lat: 1257, lng: 1674}, radius: 50 },
                { name: "RAIL CAUSEWAY", position: { lat: 935, lng: 1762 }, radius: 50 },
                { name: "LA MAISON DES ORMES", position: { lat: 608, lng: 1729 }, radius: 50 },
            ]
        },
    ],
    driel: [
        { section: 0, caps: [
                { name: "OOSTERBEEK APPROACH", position: { lat: 1807, lng: 635 }, radius: 60 },
                { name: "ROSEANDER POLDER", position: { lat: 1795, lng: 1027 }, radius: 60 },
                { name: "KASTEEL ROSANDE", position: { lat: 1771, lng:  1387}, radius: 70 },
            ]
        },
        { section: 1, caps: [
                { name: "BOATYARD", position: { lat: 1343, lng: 611 }, radius: 70 },
                { name: "BRIDGEWAY", position: { lat: 1400, lng: 1038 }, radius: 60 },
                { name: "RIJN BANKS", position: { lat: 1429, lng: 1388 }, radius: 70 },
            ]
        },
        { section: 2, caps: [
                { name: "BRICK FACTORY", position: { lat: 940, lng: 598 }, radius: 58 },
                { name: "RAILWAY BRIDGE", position: { lat: 1040, lng: 1028 }, radius: 90 },
                { name: "GUN EMPLACEMENTS", position: { lat: 1026, lng: 1436 }, radius: 55 },
            ]
        },
        { section: 3, caps: [
                { name: "RIETVELD", position: { lat: 589, lng: 589 }, radius: 59 },
                { name: "SOUTH RAILWAY", position: { lat: 576, lng: 1037 }, radius: 80 },
                { name: "MIDDEL ROAD", position: { lat: 614, lng: 1417 }, radius: 61 },
            ]
        },
        { section: 4, caps: [
                { name: "ORCHARDS", position: { lat: 223, lng: 599}, radius: 80 },
                { name: "SCHADUWWOLKEN FARM", position: { lat: 237, lng: 978 }, radius: 65 },
                { name: "FIELDS", position: { lat: 241.5, lng: 1417 }, radius: 60 },
            ]
        },
    ],
    sme: [
        { section: 0, caps: [
                { name: "FLAK POSITION", position: { lat: 1415, lng: 297 }, radius: 43 },
                { name: "VAULAVILLE", position: { lat: 1035, lng: 370 }, radius: 30 },
                { name: "LA PRAIRIE", position: { lat: 648, lng:  315}, radius: 44 },
            ]
        },
        { section: 1, caps: [
                { name: "ROUTE DU HARAS", position: { lat: 1386, lng: 586 }, radius: 44 },
                { name: "WESTERN APPROACH", position: { lat: 1138, lng: 616 }, radius: 43 },
                { name: "RUE DE GAMBOSVILLE", position: { lat: 580, lng: 648 }, radius: 45 },
            ]
        },
        { section: 2, caps: [
                { name: "HOSPICE", position: { lat: 1469, lng: 988 }, radius: 43 },
                { name: "STE MERE EGLISE", position: { lat: 1078, lng: 1059 }, radius: 50 },
                { name: "CHECKPOINT", position: { lat: 674, lng: 1003 }, radius: 45 },
            ]
        },
        { section: 3, caps: [
                { name: "ARTILLERY BATTERY", position: { lat: 1350, lng: 1400 }, radius: 45 },
                { name: "THE CEMETERY", position: { lat: 946, lng: 1292 }, radius: 45 },
                { name: "MAISON DU CRIQUE", position: { lat: 693, lng: 1259 }, radius: 45 },
            ]
        },
        { section: 4, caps: [
                { name: "LES VIEUX VERGERS", position: { lat: 1295, lng: 1708}, radius: 45 },
                { name: "THE DRAW", position: { lat: 990, lng: 1728 }, radius: 45 },
                { name: "RUISSEAU DE FERME", position: { lat: 610, lng: 1728 }, radius: 45 },
            ]
        },
    ],
    stmarie: [
        { section: 0, caps: [
                { name: "WINTERS LANDING", position: { lat: 1778, lng: 609 }, radius: 60 },
                { name: "LE GRAND CHEMIN", position: { lat: 1760, lng: 997 }, radius: 45 },
                { name: "THE BARN", position: { lat: 1735, lng:  1448}, radius: 60 },
            ]
        },
        { section: 1, caps: [
                { name: "BRECOURT BATTERY", position: { lat: 1391, lng: 611 }, radius: 60 },
                { name: "CATTLESHEDS", position: { lat: 1407, lng: 1029 }, radius: 57 },
                { name: "RUE DE LA GARE", position: { lat: 1388.5, lng: 1351 }, radius: 60 },
            ]
        },
        { section: 2, caps: [
                { name: "THE DUGOUT", position: { lat: 997, lng: 635 }, radius: 60 },
                { name: "AA NETWORK", position: { lat: 968, lng: 1018 }, radius: 65 },
                { name: "PIERRE'S FARM", position: { lat: 981, lng: 1371 }, radius: 52 },
            ]
        },
        { section: 3, caps: [
                { name: "HUGO'S FARM", position: { lat: 612, lng: 625 }, radius: 60 },
                { name: "THE HAMLET", position: { lat: 563, lng: 986 }, radius: 45 },
                { name: "STE MARIE DU MONT", position: { lat: 488, lng: 1465.5 }, radius: 61 },
            ]
        },
        { section: 4, caps: [
                { name: "THE CORNER", position: { lat: 301, lng: 658}, radius: 52 },
                { name: "HILL 6", position: { lat: 224, lng: 998 }, radius: 50 },
                { name: "FIELDS", position: { lat: 211, lng: 1393 }, radius: 47 },
            ]
        },
    ],
    utah: [
        { section: 0, caps: [
                { name: "MAMMUT RADAR", position: { lat: 1518, lng: 347 }, radius: 30 },
                { name: "FLOODED HOUSE", position: { lat: 1030, lng: 330 }, radius: 30 },
                { name: "SAINTE MARIE APPROACH", position: { lat: 467.5, lng:  348.5 }, radius: 30 },
            ]
        },
        { section: 1, caps: [
                { name: "SUNKEN BRIDGE", position: { lat: 1486, lng: 688 }, radius: 30 },
                { name: "LA GRANDE CRIQUE", position: { lat: 992, lng: 707 }, radius: 30 },
                { name: "DROWNED FIELDS", position: { lat: 580, lng: 649.5 }, radius: 45 },
            ]
        },
        { section: 2, caps: [
                { name: "WN4", position: { lat: 1424.5, lng: 1053 }, radius: 42 },
                { name: "THE CHAPEL", position: { lat: 1080, lng: 1103.5 }, radius: 30 },
                { name: "WN7", position: { lat: 494.5, lng: 1005.5 }, radius: 45 },
            ]
        },
        { section: 3, caps: [
                { name: "AA BATTERY", position: { lat: 1436, lng: 1354 }, radius: 44 },
                { name: "HILL 5", position: { lat: 1017, lng: 1361 }, radius: 30 },
                { name: "WN5", position: { lat: 557, lng: 1488 }, radius: 30 },
            ]
        },
        { section: 4, caps: [
                { name: "TARE GREEN", position: { lat: 1466.5, lng: 1641}, radius: 30 },
                { name: "RED ROOF HOUSE", position: { lat: 966, lng: 1655 }, radius: 30 },
                { name: "UNCLE RED", position: { lat: 547.5, lng: 1669.5 }, radius: 30 },
            ]
        },
    ],
    omaha: [
        { section: 0, caps: [
                { name: "BEAUMONT ROAD", position: { lat: 1359, lng: 316.5 }, radius: 53 },
                { name: "CROSSROADS", position: { lat: 978.5, lng: 342.5 }, radius: 41 },
                { name: "LES ISLES", position: { lat: 656, lng:  319 }, radius: 52 },
            ]
        },
        { section: 1, caps: [
                { name: "REAR BATTERY", position: { lat: 1489.5, lng: 586 }, radius: 54 },
                { name: "CHURCH ROAD", position: { lat: 1098.5, lng: 622.5 }, radius: 53 },
                { name: "THE ORCHARDS", position: { lat: 726.5, lng: 543.5 }, radius: 40 },
            ]
        },
        { section: 2, caps: [
                { name: "VIERVILLE SUR MERILLE", position: { lat: 1424.5, lng: 1046 }, radius: 54 },
                { name: "VIERVILLE SUR MER", position: { lat: 1034, lng: 973 }, radius: 53 },
                { name: "ARTILLERY BATTERY", position: { lat: 679.5, lng: 1022.5 }, radius: 53 },
            ]
        },
        { section: 3, caps: [
                { name: "WN73", position: { lat: 1459, lng: 1558.5 }, radius: 54 },
                { name: "WN71", position: { lat: 1066, lng: 1566 }, radius: 40 },
                { name: "WN70", position: { lat: 687, lng: 1480 }, radius: 55 },
            ]
        },
        { section: 4, caps: [
                { name: "DOG GREEN", position: { lat: 1322, lng: 1690}, radius: 65 },
                { name: "THE DRAW", position: { lat: 1080, lng: 1726 }, radius: 40 },
                { name: "DOG WHITE", position: { lat: 693.5, lng: 1732.5 }, radius: 55 },
            ]
        },
    ],
    stalin: [
        { section: 0, caps: [
                { name: "MAMAYEV APPROACH", position: { lat: 1485, lng: 338 }, radius: 60 },
                { name: "NAIL FACTORY", position: { lat: 892, lng: 326.5 }, radius: 71 },
                { name: "CITY OVERLOOK", position: { lat: 498.5, lng:  328 }, radius: 70 },
            ]
        },
        { section: 1, caps: [
                { name: "DOLGIY RAVINE", position: { lat: 1545.5, lng: 667 }, radius: 49 },
                { name: "YELLOW HOUSE", position: { lat: 973.5, lng: 591.5 }, radius: 60 },
                { name: "KOMSOMOL HQ", position: { lat: 583, lng: 579 }, radius: 71 },
            ]
        },
        { section: 2, caps: [
                { name: "RAILWAY CROSSING", position: { lat: 1419, lng: 984 }, radius: 49 },
                { name: "CARRIAGE DEPOT", position: { lat: 1000, lng: 1064 }, radius: 71 },
                { name: "TRAIN STATION", position: { lat: 658, lng: 980 }, radius: 71 },
            ]
        },
        { section: 3, caps: [
                { name: "HOUSE OF THE WORKERS", position: { lat: 1440.5, lng: 1315.5 }, radius: 49 },
                { name: "PAVLOV'S HOUSE", position: { lat: 1011, lng: 1513.5 }, radius: 44 },
                { name: "THE BREWERY", position: { lat: 568, lng: 1430 }, radius: 45 },
            ]
        },
        { section: 4, caps: [
                { name: "L-SHAPED HOUSE", position: { lat: 1351, lng: 1685}, radius: 49 },
                { name: "GRUDININ'S MILL", position: { lat: 1016, lng: 1688 }, radius: 45 },
                { name: "VOLGA BANKS", position: { lat: 565.5, lng: 1703 }, radius: 53 },
            ]
        },
    ],
    remagen: [
        { section: 0, caps: [
                { name: "ALTE LIEBE BARSCH", position: { lat: 1689, lng: 590 }, radius: 40 },
                { name: "BEWALDET KREUZUNG", position: { lat: 1687, lng: 990 }, radius: 40 },
                { name: "DAN RADART 512", position: { lat: 1681.5, lng: 1413 }, radius: 43 },
            ]
        },
        { section: 1, caps: [
                { name: "ERPEL", position: { lat: 1405.5, lng: 608 }, radius: 40 },
                { name: "ERPELER LEY", position: { lat: 1422.5, lng: 1094 }, radius: 41 },
                { name: "KASBACH OUTLOOK", position: { lat: 1406, lng: 1381 }, radius: 43 },
            ]
        },
        { section: 2, caps: [
                { name: "ST. SEVERIN CHAPEL", position: { lat: 1130, lng: 608.5 }, radius: 40 },
                { name: "LUDENDORFF BRIDGE", position: { lat: 1002.5, lng: 1028.5 }, radius: 82 },
                { name: "BAUERNHOF AM RHEIN", position: { lat: 844, lng: 1387 }, radius: 44.5 },
            ]
        },
        { section: 3, caps: [
                { name: "REMAGEN", position: { lat: 611, lng: 640 }, radius: 40 },
                { name: "MÖBELFABRIK", position: { lat: 595.5, lng: 990 }, radius: 53 },
                { name: "SCHLIEFFEN AUSWEG", position: { lat: 620, lng: 1389 }, radius: 44 },
            ]
        },
        { section: 4, caps: [
                { name: "WALDBURG", position: { lat: 208, lng: 590}, radius: 40 },
                { name: "MÜHLENWEG", position: { lat: 287, lng: 1036 }, radius: 40 },
                { name: "HAGELKREUZ", position: { lat: 317, lng: 1372 }, radius: 40 },
            ]
        },
    ],
    phl: [
        { section: 0, caps: [
                { name: "BLOODY BEND", position: { lat: 1695.5, lng: 455 }, radius: 29 },
                { name: "DEAD MAN'S CORNER", position: { lat: 1657.5, lng: 999.5 }, radius: 43 },
                { name: "FORWARD BATTERY", position: { lat: 1671, lng: 1331 }, radius: 44 },
            ]
        },
        { section: 1, caps: [
                { name: "JOURDAN CANAL", position: { lat: 1383.5, lng: 571 }, radius: 29 },
                { name: "DOUVE BRIDGE", position: { lat: 1263, lng: 975.5 }, radius: 44 },
                { name: "DOUVE RIVER BATTERY", position: { lat: 1368, lng: 1334 }, radius: 44 },
            ]
        },
        { section: 2, caps: [
                { name: "GROULT PILLBOX", position: { lat: 1059, lng: 610 }, radius: 50 },
                { name: "CARENTAN CAUSEWAY", position: { lat: 984.5, lng: 999.5 }, radius: 42 },
                { name: "FLAK POSITION", position: { lat: 1043, lng: 1451.5 }, radius: 44 },
            ]
        },
        { section: 3, caps: [
                { name: "MADELEINE FARM", position: { lat: 697.5, lng: 656 }, radius: 42 },
                { name: "MADELEINE BRIDGE", position: { lat: 601, lng: 1016 }, radius: 29 },
                { name: "AID STATION", position: { lat: 633.5, lng: 1503.5 }, radius: 29 },
            ]
        },
        { section: 4, caps: [
                { name: "INGOUF CROSSROADS", position: { lat: 332, lng: 620.5 }, radius: 42 },
                { name: "ROAD TO CARENTAN", position: { lat: 359, lng: 1018 }, radius: 29 },
                { name: "CABBAGE PATCH", position: { lat: 287, lng: 1454 }, radius: 29 },
            ]
        },
    ],
    mortain: [
        { section: 0, caps: [
                { name: "HOTEL DE LA POSTE", position: { lat: 1472.5, lng: 282 }, radius: 46 },
                { name: "FORWARD BATTERY", position: { lat: 954, lng: 286 }, radius: 46 },
                { name: "SOUTHERN APPROACH", position: { lat: 492, lng: 328 }, radius: 60 },
            ]
        },
        { section: 1, caps: [
                { name: "MORTAIN OUTSKIRTS", position: { lat: 1399, lng: 508 }, radius: 56 },
                { name: "FORWARD MEDICAL AID STATION", position: { lat: 1002, lng: 617 }, radius: 60 },
                { name: "MORTAIN APPROACH", position: { lat: 670, lng: 572 }, radius: 46 },
            ]
        },
        { section: 2, caps: [
                { name: "HILL 314", position: { lat: 1376, lng: 994 }, radius: 61 },
                { name: "PETIT CHAPPELLE SAINT MICHEL", position: { lat: 941, lng: 1016 }, radius: 47 },
                { name: "US SOUTHERN ROADBLOCK", position: { lat: 478, lng: 872 }, radius: 47 },
            ]
        },
        { section: 3, caps: [
                { name: "DESTROYED GERMAN CONVOY", position: { lat: 1423, lng: 1355 }, radius: 74 },
                { name: "GERMAN RECON CAMP", position: { lat: 1026, lng: 1404 }, radius: 52 },
                { name: "LE HERMITAGE FARM", position: { lat: 739.5, lng: 1459 }, radius: 65 },
            ]
        },
        { section: 4, caps: [
                { name: "ABANDONDED GERMAN CHECKPOINT", position: { lat: 1403, lng: 1686 }, radius: 46 },
                { name: "GERMAN DEFENSIVE CAMP", position: { lat: 987, lng: 1698 }, radius: 46 },
                { name: "FARM OF BONOVISIN", position: { lat: 632.5, lng: 1713 }, radius: 65 },
            ]
        },
    ],
    elalamein: [
        { section: 0, caps: [
                { name: "VEHICLE DEPOT", position: { lat: 1376, lng: 325 }, radius: 60 },
                { name: "ARTILLERY GUNS", position: { lat: 1081, lng: 290 }, radius: 60 },
                { name: "MITEIRIYA RIDGE", position: { lat: 636, lng: 214 }, radius: 61 },
            ]
        },
        { section: 1, caps: [
                { name: "HAMLET RUINS", position: { lat: 1374.2, lng: 628.5 }, radius: 60 },
                { name: "EL MREIR", position: { lat: 1029, lng: 625 }, radius: 60 },
                { name: "WATCHTOWER", position: { lat: 625, lng: 595.5 }, radius: 60 },
            ]
        },
        { section: 2, caps: [
                { name: "DESERT RAT TRENCHES", position: { lat: 1407, lng: 1048.5 }, radius: 60 },
                { name: "OASIS", position: { lat: 1009, lng: 972 }, radius: 60 },
                { name: "VALLEY", position: { lat: 650.8, lng: 1019.2 }, radius: 82 },
            ]
        },
        { section: 3, caps: [
                { name: "FUEL DEPOT", position: { lat: 1359, lng: 1417 }, radius: 80 },
                { name: "AIRFIELD COMMAND", position: { lat: 1041, lng: 1382 }, radius: 60 },
                { name: "AIRFIELD HANGARS", position: { lat: 690.7, lng: 1397.2 }, radius: 100 },
            ]
        },
        { section: 4, caps: [
                { name: "CLIFFSIDE VILLAGE", position: { lat: 1387.5, lng: 1684.4 }, radius: 60 },
                { name: "AMBUSHED CONVOY", position: { lat: 1025.5, lng: 1719.5 }, radius: 60 },
                { name: "QUARRY", position: { lat: 587.2, lng: 1779 }, radius: 71 },
            ]
        },
    ],
    kursk: [
        { section: 0, caps: [
                { name: "ARTILLERY POSITION", position: { lat: 1683, lng: 651 }, radius: 60 },
                { name: "GRUSHKI", position: { lat: 1675.5, lng: 1068 }, radius: 47 },
                { name: "GRUSHKI FLANK", position: { lat: 1666.6, lng: 1465.5 }, radius: 47 },
            ]
        },
        { section: 1, caps: [
                { name: "PANZER'S END", position: { lat: 1318.5, lng: 649 }, radius: 60 },
                { name: "DEFENCE IN DEPTH", position: { lat: 1347.3, lng: 1014.3 }, radius: 69 },
                { name: "LISTENING POST", position: { lat: 1358, lng: 1399.5 }, radius: 75 },
            ]
        },
        { section: 2, caps: [
                { name: "THE WINDMILLS", position: { lat: 1049.5, lng: 734 }, radius: 60 },
                { name: "YAMKI", position: { lat: 962, lng: 1093.5 }, radius: 70 },
                { name: "OLEG'S HOUSE", position: { lat: 925.5, lng: 1390 }, radius: 52 },
            ]
        },
        { section: 3, caps: [
                { name: "RUDNO", position: { lat: 606, lng: 730 }, radius: 60 },
                { name: "DESTROYED BATTERY", position: { lat: 605.5, lng: 989 }, radius: 44 },
                { name: "THE MUDDY CHURN", position: { lat: 580.5, lng: 1407 }, radius: 51 },
            ]
        },
        { section: 4, caps: [
                { name: "ROAD TO KURSK", position: { lat: 327.5, lng: 686}, radius: 46 },
                { name: "AMMO DUMP", position: { lat: 344, lng: 981 }, radius: 54 },
                { name: "EASTERN POSITION", position: { lat: 350, lng: 1355.3 }, radius: 60 },
            ]
        },
    ],
    kharkov: [
        { section: 0, caps: [
                { name: "MARSH TOWN", position: { lat: 1712, lng: 631.3 }, radius: 40 },
                { name: "SOVIET VANTAGE POINT", position: { lat: 1713, lng: 1080 }, radius: 39 },
                { name: "GERMAN FUEL DUMP", position: { lat: 1708, lng: 1413.5 }, radius: 39 },
            ]
        },
        { section: 1, caps: [
                { name: "BITTER SPRING", position: { lat: 1392, lng: 622 }, radius: 82 },
                { name: "LUMBER WORKS", position: { lat: 1401.5, lng: 1078.5 }, radius: 39 },
                { name: "WINDMILL HILLSIDE", position: { lat: 1417.5, lng: 1471 }, radius: 39 },
            ]
        },
        { section: 2, caps: [
                { name: "WATER MILL", position: { lat: 1036.5, lng: 629 }, radius: 51 },
                { name: "ST MARY", position: { lat: 1007.5, lng: 1060 }, radius: 61 },
                { name: "DISTILLERY", position: { lat: 1046.5, lng: 1446.5 }, radius: 39 },
            ]
        },
        { section: 3, caps: [
                { name: "RIVER CROSSING", position: { lat: 598, lng: 726 }, radius: 39 },
                { name: "BELGOROD OUTSKIRTS", position: { lat: 611, lng: 1080 }, radius: 91 },
                { name: "LUMBERYARD", position: { lat: 623.7, lng: 1470 }, radius: 39 },
            ]
        },
        { section: 4, caps: [
                { name: "WEHRMACHT OUTLOOK", position: { lat: 266.5, lng: 623 }, radius: 39 },
                { name: "HAY STORAGE", position: { lat: 279, lng: 1041.5 }, radius: 39 },
                { name: "OVERPASS", position: { lat: 292.5, lng: 1413.5 }, radius: 38 },
            ]
        },
    ],
    hurtgen: [
        { section: 0, caps: [
                { name: "THE MAUSBACH APPROACH", position: { lat: 1470.5, lng: 259 }, radius: 45.5 },
                { name: "RESERVE STATION", position: { lat: 982.5, lng: 214 }, radius: 45 },
                { name: "LUMBER YARD", position: { lat: 651.6, lng: 228.5 }, radius: 45 },
            ]
        },
        { section: 1, caps: [
                { name: "WEHEBACH OVERLOOK", position: { lat: 1350, lng: 617.8 }, radius: 49 },
                { name: "KALL TRAIL", position: { lat: 984.5, lng: 641.7 }, radius: 60 },
                { name: "THE RUIN", position: { lat: 745.3, lng: 572.5 }, radius: 45 },
            ]
        },
        { section: 2, caps: [
                { name: "NORTH PASS", position: { lat: 1496.5, lng: 1062 }, radius: 42 },
                { name: "THE SCAR", position: { lat: 974, lng: 926.5 }, radius: 29 },
                { name: "THE SIEGRIED LINE", position: { lat: 587.2, lng: 961 }, radius: 44 },
            ]
        },
        { section: 3, caps: [
                { name: "HILL 15", position: { lat: 1348, lng: 1449.5 }, radius: 43 },
                { name: "JACOB'S BARN", position: { lat: 918.2, lng: 1370 }, radius: 40 },
                { name: "SALIENT 42", position: { lat: 511, lng: 1398.2 }, radius: 29 },
            ]
        },
        { section: 4, caps: [
                { name: "GROSSHAU APPROACH", position: { lat: 1391.7, lng: 1728.4 }, radius: 41 },
                { name: "HURTGEN APPROACH", position: { lat: 940.8, lng: 1670 }, radius: 40 },
                { name: "Logging Camp", position: { lat: 496.5, lng: 1635.1 }, radius: 44 },
            ]
        },
    ],
    hill400: [
        { section: 0, caps: [
                { name: "CONVOY AMBUSH", position: { lat: 1372.5, lng: 334.8 }, radius: 29 },
                { name: "FEDERHECKE JUNCTION", position: { lat: 970.4, lng: 340 }, radius: 42 },
                { name: "STUCKCHEN FARM", position: { lat: 571.3, lng: 353.5 }, radius: 29 },
            ]
        },
        { section: 1, caps: [
                { name: "ROER RIVER HOUSE", position: { lat: 1437, lng: 609.9 }, radius: 29 },
                { name: "BERGSTEIN CHURCH", position: { lat: 912, lng: 689 }, radius: 29 },
                { name: "KIRCHWEG", position: { lat: 685, lng: 583 }, radius: 29 },
            ]
        },
        { section: 2, caps: [
                { name: "FLAK PITS", position: { lat: 1337, lng: 1014.2 }, radius: 29 },
                { name: "HILL 400", position: { lat: 952, lng: 985 }, radius: 49.5 },
                { name: "SOUTHERN APPROACH", position: { lat: 745.4, lng: 1004.7 }, radius: 29 },
            ]
        },
        { section: 3, caps: [
                { name: "ESELSWEG JUNCTION", position: { lat: 1415, lng: 1265.1 }, radius: 29 },
                { name: "EASTERN SLOPE", position: { lat: 1032.8, lng: 1299.7 }, radius: 29 },
                { name: "TRAIN WRECK", position: { lat: 558.8, lng: 1320.2 }, radius: 29 },
            ]
        },
        { section: 4, caps: [
                { name: "ROER RIVER CROSSING", position: { lat: 1337, lng: 1649.2 }, radius: 29 },
                { name: "ZERKALL", position: { lat: 1096.5, lng: 1793.3}, radius: 50 },
                { name: "PAPER MILL", position: { lat: 605.8, lng: 1696.5 }, radius: 29 },
            ]
        },
    ],
    foy: [
        { section: 0, caps: [
                { name: "ROAD TO RECOGNE", position: { lat: 1760, lng: 495.2 }, radius: 27 },
                { name: "COBRU APPROACH", position: { lat: 1764.2, lng: 1096.5 }, radius: 37 },
                { name: "ROAD TO NOVILLE", position: { lat: 1788.2, lng: 1382.8 }, radius: 58 },
            ]
        },
        { section: 1, caps: [
                { name: "COBRU FACTORY", position: { lat: 1457, lng: 695.5 }, radius: 58 },
                { name: "FOY", position: { lat: 1352.7, lng: 902.7 }, radius: 37 },
                { name: "FLAK BATTERY", position: { lat: 1412, lng: 1456 }, radius: 44 },
            ]
        },
        { section: 2, caps: [
                { name: "WEST BEND", position: { lat: 1136, lng: 459.8 }, radius: 58 },
                { name: "SOUTHERN EDGE", position: { lat: 989.4, lng: 993.5 }, radius: 41.5 },
                { name: "DUGOUT BARN", position: { lat: 1057.3, lng: 1461.2 }, radius: 43 },
            ]
        },
        { section: 3, caps: [
                { name: "N30 HIGHWAY", position: { lat: 687, lng: 608 }, radius: 58 },
                { name: "BIZORY-FOY ROAD", position: { lat: 609, lng: 1098.5 }, radius: 43 },
                { name: "EASTERN OURTHE", position: { lat: 730, lng: 1461 }, radius: 44 },
            ]
        },
        { section: 4, caps: [
                { name: "ROAD TO BASTOGNE", position: { lat: 366, lng: 463 }, radius: 45 },
                { name: "BOIS JACQUES", position: { lat: 321.3, lng: 941 }, radius: 49 },
                { name: "FOREST OUTSKIRTS", position: { lat: 333, lng: 1464 }, radius: 49 },
            ]
        },
    ],
    elsenborn: [
        { section: 0, caps: [
                { name: "99TH COMMAND CENTRE", position: { lat: 1674, lng: 607.5 }, radius: 70 },
                { name: "GUN BATTERY", position: { lat: 1691, lng: 1007.5 }, radius: 75 },
                { name: "U.S. CAMP", position: { lat: 1673, lng: 1512 }, radius: 65 },
            ]
        },
        { section: 1, caps: [
                { name: "ELSENBORN RIDGE", position: { lat: 1417, lng: 694 }, radius: 65 },
                { name: "FARAHILDE FARM", position: { lat: 1301.5, lng: 1104 }, radius: 74 },
                { name: "JENSIT PILLBOXES", position: { lat: 1280, lng: 1497.5 }, radius: 65 },
            ]
        },
        { section: 2, caps: [
                { name: "ROAD TO ELSENBORN RIDGE", position: { lat: 967.5, lng: 595 }, radius: 74 },
                { name: "DUG OUT TANK", position: { lat: 976, lng: 912 }, radius: 55 },
                { name: "CHECKPOINT", position: { lat: 934, lng: 1406 }, radius: 47 },
            ]
        },
        { section: 3, caps: [
                { name: "ERELSDELL FARMHOUSE", position: { lat: 619.3, lng: 586.5 }, radius: 75 },
                { name: "AA BATTERY", position: { lat: 669, lng: 1088.7 }, radius: 65 },
                { name: "HINTERBURG", position: { lat: 601.5, lng: 1397 }, radius: 74 },
            ]
        },
        { section: 4, caps: [
                { name: "SUPPLY CACHE", position: { lat: 339.5, lng: 745.5 }, radius: 46 },
                { name: "FOXHOLES", position: { lat: 331, lng: 1124 }, radius: 64 },
                { name: "FUEL DEPOT", position: { lat: 297.5, lng: 1381.5 }, radius: 64 },
            ]
        },
    ],
}